import { motion } from "framer-motion"
import PropTypes from "prop-types"
import React from "react"
import uid from "uid"

class FadeTransitionText extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      currentText: props.texts[0],
      nextText: undefined,
      height: 0,
    }
    this.uid = uid()
    this.currentRef = React.createRef()
    this.nextRef = React.createRef()
  }

  animateTo(text) {
    this.setState({
      nextText: text,
    })

    setTimeout(() => {
      this.updateHeight()
    }, 100)

    setTimeout(() => {
      this.setState({
        currentText: this.state.nextText
          ? this.state.nextText
          : this.state.currentText,
      })
      setTimeout(() => {
        this.setState({
          nextText: undefined,
        })
      }, 10)
    }, 150)
  }

  updateHeight(includeCurrent = false) {
    const heights = [0]
    if (includeCurrent && this.currentRef.current) {
      heights.push(this.currentRef.current.scrollHeight)
    }
    if (this.nextRef.current) {
      heights.push(this.nextRef.current.scrollHeight)
    }

    this.setState({
      height: Math.max(...heights),
    })
  }

  componentDidMount() {
    this.updateHeight(true)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeIndex !== this.props.activeIndex) {
      const length = this.props.texts.length
      let newIndex = this.props.activeIndex
      while (newIndex < 0) {
        newIndex += length
      }
      newIndex = newIndex % length
      this.animateTo(this.props.texts[newIndex])
    }
  }

  render() {
    return (
      <motion.div
        style={{ position: "relative", overflow: "hidden" }}
        animate={{ height: this.state.height }}
        transition={{ ease: "easeOut" }}
        initial={false}
      >
        <motion.div
          ref={this.currentRef}
          initial={false}
          animate={{ opacity: this.state.nextText ? 0 : 1 }}
          transition={{ duration: this.state.nextText ? undefined : 0 }}
        >
          {this.state.currentText}
        </motion.div>
        <div
          style={{ position: "absolute", top: 0, width: "100%" }}
          ref={this.nextRef}
        >
          {!!this.state.nextText && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              {this.state.nextText}
            </motion.div>
          )}
        </div>
      </motion.div>
    )
  }
}

FadeTransitionText.propTypes = {
  texts: PropTypes.arrayOf(PropTypes.string),
  activeIndex: PropTypes.number,
}

export default FadeTransitionText
